<button
  odxButton
  [variant]="odxVariant"
  size="medium"
  class="menu-button"
  [ngStyle]="{ width: expanded ? '100%' : '36px' }"
  [odxTooltip]="title"
  [odxTooltipDisabled]="expanded"
  [odxTooltipOptions]="{ delayIn: 0 }"
>
  <div odxLayout="flex vertical-center" class="w-100">
    <div odxLayout="flex vertical center" class="icon-flex">
      @if (odxIcon) {
        <odx-icon [name]="odxIcon!" size="medium"></odx-icon>
      }
      @if (imageUrl) {
        <img alt="" [src]="imageUrl" />
      }
    </div>
    @if (expanded) {
      <div odxLayout="flex gap-small">{{ title }}</div>
    }
  </div>
</button>
